var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:'img-display img-'+(_vm.index+1),attrs:{"src":_vm.data.images_sm[_vm.index]}})}
var staticRenderFns = []

export { render, staticRenderFns }